// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"assets_i18n_en_translation_json":"e5d0d3ca6f0a2d5e7cac","assets_i18n_nl_translation_json":"d85f2c41a78f858e945d"}[chunkId] + ".chunk.js";
};